import { createFileRoute } from '@tanstack/react-router';

import { ListsLayout } from '../features/supply/lists/ListsLayout/ListsLayout';

export const Route = createFileRoute('/supply/lists')({ component: ListsLayout });
